module.exports = __webpack_public_path__ + "static/img/5.ee87f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020.3.26/5.jpg
// module id = +VkH
// module chunks = 1